export const colors = {
  primary: '#e5e4e8',
  secondary: '#202022',
  light: '#e5e4e8',
  lightgrey: '#acacac',
  skyblue: '#1586d9',
  deepdarkgrey: '#2a2d33',
  deepergrey: '#19191b',
  transparent: 'transparent',
  white: '#ffffff',
  chat: '#0080CF',
  bluish1: '#D6E8ED',
  bluish2: '#C2DEE6',
  bluish3: '#99C7D4',
  green1: '#A6CCD1',
  green2: '#4F99A6',
  green3: '#21828F',
  orange1: '#FFD0C0',
  orange2: '#FFB096',
  orange3: '#FF916D',
  orange4: '#FF7243',
  orange5: '#FF531A',
  orange6: '#D14416',
  errorRed: '#FF1A1A',
  gray1: '#F5F5F5',
  gray2: '#EFEFEF',
  gray3: '#E6E5E8',
  gray4: '#B5B5B8',
  gray5: '#828587',
  teal1: '#99ABB3',
  teal2: '#638290',
  teal3: '#335766',
  teal4: '#003E56',
  teal5: '#002B40',
  midnight: '#001C29',
}
export const opacity = [
  '00',
  '1A',
  '33',
  '4D',
  '66',
  '80',
  '99',
  'B3',
  'CC',
  'E6',
  'FF	',
]
